module.exports = __webpack_public_path__ + "static/images/o-week.1871a20.png";